"use strict";

exports.__esModule = true;
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  exports[key] = _constants[key];
});
var _determineLocale = require("./determineLocale");
Object.keys(_determineLocale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _determineLocale[key]) return;
  exports[key] = _determineLocale[key];
});